var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 57,
    viewBox: "0 0 233 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5422 20.5277H79.6141V45.7677H73.0287V20.5277H64.1006V14.1973H88.5422V20.5277Z",
    fill: "#02124E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5977 45.7679V32.6723C91.5977 26.8146 94.9007 22.3447 101.638 22.3447C103.104 22.3447 104.708 22.6223 105.855 23.1262V29.4878C104.759 28.8451 103.423 28.5164 102.233 28.5164C99.6629 28.5164 98.1094 30.1744 98.1094 32.8987V45.7679H91.5977Z",
    fill: "#02124E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.91 14.337C108.91 12.0411 110.776 10.124 113.01 10.124C115.244 10.124 117.057 12.0411 117.057 14.337C117.057 16.633 115.244 18.5501 113.01 18.5501C110.776 18.5501 108.91 16.686 108.91 14.337ZM116.313 22.0887V45.768H109.699V22.0887H116.313Z",
    fill: "#02124E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.167 34.5433C123.167 27.8593 128.496 22.3447 135.367 22.3447C142.238 22.3447 147.609 27.9037 147.609 34.5433C147.609 41.183 142.281 46.7863 135.367 46.7863C128.452 46.7863 123.167 41.2718 123.167 34.5433ZM141.149 34.5877C141.149 31.316 138.69 28.6069 135.367 28.6069C132.043 28.6069 129.628 31.316 129.628 34.5877C129.628 37.8594 132.043 40.5686 135.367 40.5686C138.69 40.5686 141.149 37.8594 141.149 34.5877Z",
    fill: "#02124E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.683 34.1622C151.683 26.7162 156.505 21.4918 163.518 21.4918C165.796 21.4918 167.98 22.3651 169.616 23.767L169.659 11.1426H176.125V34.1622C176.125 41.4166 170.935 46.7866 163.886 46.7866C156.837 46.7866 151.69 41.0796 151.69 34.1622H151.683ZM169.659 34.1622C169.659 30.7763 167.201 27.9726 163.879 27.9726C160.556 27.9726 158.141 30.7763 158.141 34.1622C158.141 37.5481 160.556 40.3059 163.879 40.3059C167.201 40.3059 169.659 37.5481 169.659 34.1622Z",
    fill: "#02124E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M182.242 33.9603C182.242 27.0376 186.857 21.3262 193.641 21.3262C200.426 21.3262 204.64 26.938 204.64 33.4774V35.509H188.318C188.76 38.7058 191.022 40.8371 194.168 40.8371C196.563 40.8371 198.558 39.5798 199.576 37.3489L204.408 40.0091C202.505 44.3176 198.867 46.7862 194.21 46.7862C187.384 46.7862 182.235 41.6037 182.235 33.9603H182.242ZM198.382 31.6834C198.115 29.2149 196.254 27.3289 193.592 27.3289C190.93 27.3289 189.027 29.2685 188.585 31.6834H198.382Z",
    fill: "#02124E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209.732 34.5655C209.732 27.825 215.039 22.3005 221.796 22.345C226.105 22.3895 230.09 24.4065 232.137 28.9002L226.83 31.896C225.832 29.8864 224.022 28.6184 221.796 28.6184C218.579 28.6184 216.173 31.2879 216.173 34.5655C216.173 37.8431 218.579 40.5127 221.796 40.5127C224.015 40.5127 225.832 39.2446 226.83 37.2351L232.137 40.2309C230.097 44.7246 226.105 46.7416 221.796 46.7861C215.039 46.8306 209.732 41.2616 209.732 34.5655Z",
    fill: "#02124E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8812 18.8004L32.0639 25.0567C35.8223 32.4394 34.5651 41.4181 28.9407 47.4598C26.2344 50.3633 24.1765 52.5761 24.1765 52.5761C22.2113 54.6682 24.6794 58.0344 27.2335 56.6933L49.8437 44.8782C51.8155 43.8925 53.0397 42.0216 53.4301 39.9899C53.9329 37.663 53.2779 35.1418 51.445 33.3916L32.9506 15.6958C30.8861 13.7043 27.5644 16.2054 28.8878 18.7937L28.8812 18.8004Z",
    fill: "url(#paint0_linear_1424_121)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5683 28.6581L32.4477 15.2336C31.0449 13.9127 27.5049 13.2488 25.3213 15.5153C23.4685 17.4532 22.5818 25.4998 35.0482 25.8082C39.4154 25.9155 40.7718 25.8686 46.5683 28.6581Z",
    fill: "url(#paint1_linear_1424_121)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7121 38.1996L21.5293 31.9433C17.7709 24.5605 19.0281 15.5819 24.6525 9.54021C27.3589 6.63672 29.4168 4.4239 29.4168 4.4239C31.382 2.33178 28.9139 -1.03438 26.3597 0.30672L3.7496 12.1218C1.77774 13.1075 0.553608 14.9784 0.163208 17.0101C-0.33968 19.337 0.315397 21.8582 2.14829 23.6084L20.6427 41.3042C22.7072 43.2957 26.0289 40.7946 24.7055 38.2063L24.7121 38.1996Z",
    fill: "url(#paint2_linear_1424_121)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02547 28.3419L21.146 41.7664C22.5488 43.0873 26.0889 43.7512 28.2725 41.4847C30.1252 39.5468 31.0119 31.5002 18.5456 31.1918C14.1784 31.0845 12.8219 31.1314 7.02547 28.3419Z",
    fill: "url(#paint3_linear_1424_121)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1424_121",
    x1: 33.7789,
    y1: 22.3452,
    x2: 24.6417,
    y2: 55.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0466C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71BDF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1424_121",
    x1: 38.1289,
    y1: 31.1358,
    x2: 26.6852,
    y2: 18.5491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95D1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1298FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1424_121",
    x1: 10.8862,
    y1: 36.7138,
    x2: 18.5994,
    y2: 0.164781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0466C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71BDF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1424_121",
    x1: 15.4649,
    y1: 25.8642,
    x2: 26.9085,
    y2: 38.4509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95D1FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1298FB"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.956c90ec52398532ae56826b849bb6a8.svg";
export { ForwardRef as ReactComponent };